const LayerIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2616_73055)">
        <path
          d="M1.66406 10.0029L9.69925 14.0205C9.80857 14.0752 9.86323 14.1025 9.92056 14.1132C9.97134 14.1228 10.0235 14.1228 10.0742 14.1132C10.1316 14.1025 10.1862 14.0752 10.2955 14.0205L18.3307 10.0029M1.66406 14.1696L9.69925 18.1872C9.80857 18.2418 9.86323 18.2692 9.92056 18.2799C9.97134 18.2894 10.0235 18.2894 10.0742 18.2799C10.1316 18.2692 10.1862 18.2418 10.2955 18.1872L18.3307 14.1696M1.66406 5.83624L9.69925 1.81864C9.80857 1.76398 9.86323 1.73665 9.92056 1.7259C9.97134 1.71637 10.0235 1.71637 10.0742 1.7259C10.1316 1.73665 10.1862 1.76398 10.2955 1.81864L18.3307 5.83624L10.2955 9.85383C10.1862 9.90849 10.1316 9.93582 10.0742 9.94658C10.0235 9.9561 9.97134 9.9561 9.92056 9.94658C9.86323 9.93582 9.80857 9.90849 9.69925 9.85383L1.66406 5.83624Z"
          stroke="#F1F1F1"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2616_73055">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LayerIcon;
